/* eslint-disable react/require-default-props */
import { Box } from '@mui/material'
import { useNavigate } from 'react-router-dom'

const MarsLogo = '/assets/MARSLogo.png'

type LogoProps = {
  className?: string
  navigateTo?: string
  style?: object
  logo?: string
}

function Logo({
  className,
  navigateTo,
  style = {},
  logo = MarsLogo,
}: LogoProps) {
  const navigate = useNavigate()
  return (
    <Box
      className={className}
      component='img'
      src={process.env.PUBLIC_URL + logo}
      alt='Logo'
      onClick={navigateTo ? () => navigate(navigateTo) : undefined}
      style={style}
    />
  )
}

export default Logo
